import React, { JSX } from 'react';

export const FaceLivenessSuccess: React.FC = (): JSX.Element => (
  <div className="event w-full container mx-auto mb-36 lg">
    <div className="flex flex-col items-center text-center">
      <div className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-green-50 text-green-600">
        <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
          <path
            d="M20 6L9 17l-5-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h2 id="liveness-success-title" className="text-lg font-semibold">
        Verificação concluída!
      </h2>
      <p className="mt-1 text-sm text-gray-600">Sua foto passou na checagem de Biometria Facial.</p>
    </div>
  </div>
);
